import { Link, useLocation, useParams } from "react-router-dom";
import { TbRosetteDiscount } from "react-icons/tb";
import { BiCoinStack } from "react-icons/bi";
import { FaRegUserCircle } from "react-icons/fa";
import { LuHeartHandshake } from "react-icons/lu";
import { MdOutlineMosque } from "react-icons/md";
import { PiGearSixBold } from "react-icons/pi";

const menus = [
  { label: "Topup Points", href: "/", icon: BiCoinStack },
  { label: "Biodata", href: "/biodata", icon: FaRegUserCircle },
  { label: "Cari Pasangan", href: "/cari-pasangan", icon: LuHeartHandshake },
  { label: "Ta'aruf", href: "/taaruf", icon: MdOutlineMosque },
  { label: "Settings", href: "/settings", icon: PiGearSixBold },
  { label: "Bonus Point", href: "/bonus", icon: TbRosetteDiscount },
];

export default function Layout({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();

  return (
    <div className="sk-mx-auto sk-max-w-7xl sk-py-[60px]">
      <div className="sk-bg-white sk-w-full sk-h-[700px] sk-shadow sk-rounded-2xl sk-flex sk-overflow-hidden">
        <div className="sk-hidden sk-flex-shrink-0 lg:sk-block sk-w-[300px] sk-p-2">
          <ul>
            {menus.map((menu, index) => (
              <li>
                <Link
                  to={menu.href}
                  className={`sk-px-[15px] sk-py-[10px] sk-block sk-text-neutral-800 sk-font-semibold sk-rounded-xl ${
                    pathname === menu.href
                      ? "sk-bg-[#FFEDF3] !sk-text-primary"
                      : ""
                  }`}
                >
                  <menu.icon className="sk-inline-block sk-mr-[10px] sk-text-xl" />
                  {menu.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        {children}
      </div>
    </div>
  );
}
